<template>

    <a :href="href"
        class="blockl h-full">

        <img class="h-full"
            src="/images/logo.png"
            alt="Pausefitness" />

    </a>

</template>

<script>
import { defineComponent } from 'vue'
import { Link } from '@inertiajs/inertia-vue3';

export default defineComponent({

    components: {
        Link,
    },

    props: {
        href: {
            type: String,
            default: '/'
        },
    }

});
</script>
